// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
//console.log('root.jsx, start')

import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {Router, Route} from 'react-router-dom';

// Import our styles
import 'bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css';
import './sass/styles.scss';
import 'katex/dist/katex.min.css';

//utils file, then calls history node_modules package
import {browserHistory} from 'utils/browser_history';
import {makeAsyncComponent} from 'components/async_load';
//this runs before any root.jsx  console.log()
//which runs store/index.js stuff
import store from 'stores/redux_store.jsx';

//this looks like older 0.5.5 version syntax
import loadRoot from 'bundle-loader?lazy!components/root.jsx';
//import ReactGA from 'react-ga';

//console.log('root.jsx, finished imports')
//Client4 does not exist yet
//console.log(Client4)

//ReactGA.initialize('UA-147223628-1'); //app.boomea.com
//ReactGA.pageview('/spa');
//ex: ReactGA.pageview(window.location.pathname + window.location.search);

// listen does not respond to pushes
// browserHistory.listen(location => {
//   ReactGA.set({ page: location.pathname }); // Update the user's current page
//   ReactGA.pageview(location.pathname); // Record a pageview for the given page
// });
// see https://github.com/react-ga/react-ga/wiki/React-Router-v4-withTracker


function logToApm(message, line, column, err) {
    if (typeof newrelic == 'undefined' || !newrelic) {
        return
    }
    if (err != undefined) {
        newrelic.noticeError(err, { errorscope: 'global'})
        return
    }
    var errMessage = "JavaScript error: " + message + " (row: " + line + " col: " + column + ")";
    newrelic.noticeError(errMessage, { errorscope: 'global'});
}

const Root = makeAsyncComponent(loadRoot);
global.images = require.context('images', true);
// This is for anything that needs to be done for ALL react components.
// This runs before we start to render anything.
function preRenderSetup(callwhendone) {
    //console.log('root.jsx, inside preRenderSetup()')
    window.onerror = (msg, url, line, column, stack) => {
        logToApm(msg, line, column, stack);
        if (window.mm_config && window.mm_config.EnableDeveloper === 'true') {
            window.ErrorStore.storeLastError({type: 'developer', message: 'DEVELOPER MODE: A JavaScript error has occurred.  Please use the JavaScript console to capture and report the error (row: ' + line + ' col: ' + column + ').'});
            window.ErrorStore.emitChange();
        }
    };
    callwhendone();
}

function renderRootComponent() {
    //console.log('root.jsx, renderRootComponent(), top')
    const container = document.getElementById('root');
    const root = ReactDOM.createRoot(container);
    root.render(
        <Provider store={store}>
            <Router history={browserHistory}>
                <Route
                    path='/'
                    component={Root}
                />
            </Router>
        </Provider>
    );
    //console.log('root.jsx, renderRootComponent(), bottom')
    //Client4 does not exist yet
    //console.log(Client4)
}

/**
 * Adds a function to be invoked onload appended to any existing onload
 * event handlers.
 *
 * @param   {function} fn onload event handler
 *
 */
function appendOnLoadEvent(fn) {
    //https://stackoverflow.com/questions/30914727/what-is-the-difference-between-addeventlistener-and-attachevent
    //https://msdn.microsoft.com/en-us/windows/ms536343(v=vs.71)
    //[attachEvent is no longer supported. Starting with Internet Explorer 11, use addEventListener. For info, see Compatibility changes.]
    //console.log('root.jsx, inside appendOnLoadEvent()')
    //console.log(window.attachEvent) //output = undefined
    //console.log(window.onload) //output = null
    if (window.attachEvent) {
        //this handled ie8 old stuff
        //console.log('running old ie8 onload stuff')
        window.attachEvent('onload', fn);
    } else if (window.onload) {
        //guessing this handles case where an onload already exists
        //not sure when this would ever happen
        //console.log('running onload, with preexisting onload')
        const curronload = window.onload;
        window.onload = (evt) => {
            curronload(evt);
            fn(evt);
        };
    } else {
        //console.log('root.jsx, appendOnLoadEvent(), before setting window.onload (single mattermost onload)')
        window.onload = fn;
    }
}

//console.log('root.jsx, after functions defined')

//this calls the function created above
//and passes in as a param the function that calls preRenderSetup(...)
appendOnLoadEvent(() => {
    // Do the pre-render setup and call renderRootComponent when done
    //note that this console.log() will not appear until fn is invoked by window.onload, which is set appendOnLoadEvent() above
    //console.log('root.jsx, appendOnLoadEvent, which originates from window.onload')
    preRenderSetup(renderRootComponent);
});
